var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrimaryConsumerWithDda = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3233 19.1247C21.492 19.1247 23.25 18.5652 23.25 17.8751C23.25 17.1849 21.492 16.6254 19.3233 16.6254C17.1546 16.6254 15.3965 17.1849 15.3965 17.8751C15.3965 18.5652 17.1546 19.1247 19.3233 19.1247Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3233 21.3129C21.4919 21.3129 23.25 20.7532 23.25 20.0632V19.271C22.0139 20.0097 19.886 20.0632 19.3233 20.0632C18.7605 20.0632 16.6326 20.0097 15.3965 19.271V20.0632C15.3956 20.7532 17.1537 21.3129 19.3233 21.3129Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3233 22.2503C18.7605 22.2503 16.6326 22.1969 15.3965 21.4581V22.2503C15.3965 22.9403 17.1546 23.5 19.3233 23.5C21.4919 23.5 23.25 22.9403 23.25 22.2503V21.4581C22.0139 22.1959 19.886 22.2503 19.3233 22.2503Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4893 17.6463L14.5156 17.6622C14.7874 15.7909 18.5448 15.6878 19.3223 15.6878C19.8869 15.6878 22.0175 15.7459 23.2491 16.4922V10.2184C23.25 9.27063 22.5051 8.5 21.5888 8.5H10.4112C9.49494 8.5 8.75 9.27063 8.75 10.2184V16.7809C8.75 17.7288 9.49494 18.4994 10.4112 18.4994H14.4893V17.6463ZM12.5263 11.3125H11.0156C10.7655 11.3125 10.5625 11.1025 10.5625 10.8438C10.5625 10.585 10.7655 10.375 11.0156 10.375H12.5263C12.7765 10.375 12.9795 10.585 12.9795 10.8438C12.9795 11.1025 12.7765 11.3125 12.5263 11.3125ZM16 11.3125C17.1663 11.3125 18.1143 12.2941 18.1143 13.4997C18.1143 14.7053 17.1663 15.6878 16 15.6878C14.8337 15.6878 13.8857 14.7062 13.8857 13.5006C13.8857 12.295 14.8337 11.3125 16 11.3125Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrimaryConsumerWithDda);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/primary_consumer_with_dda.5e7514c0820ff9b996e85deb8b7ea874.svg";